<template>
  <router-view/>
</template>

<script>
export default {}
</script>

<style lang="scss">
:root {
  --popper-theme-background-color: #F8F9FA;
  --popper-theme-background-color-hover: #F8F9FA;
  --popper-theme-text-color: #000000;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 2px;
  --popper-theme-padding: 16px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.h-70 {
  height: 70px;
}

.h-160 {
  height: 160px;
}

.w-300 {
  width: 300px !important;
}

.w-400 {
  width: 400px !important;
}

.mw-4000 {
  min-width: 2100px;
}

.text-sm {
  font-size: .8rem;
}

.text-darker {
  color: #bbb;
}

#btn-back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
  z-index: 10000;
}

.leaflet-right .leaflet-routing-container.leaflet-routing-container-hide {
  display: none !important;
}
</style>
